

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
let { lambda, country, appname } = window.app;




const TableLoader = () => {
    const navigate = useNavigate();
    const [image, setImg] = useState(process.env.REACT_APP_IMAGE_CLOUD_FRONT);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    
    
    }, [window.site]);

    return (

        <>
            <div className="table-preloader">
                <div className="orasi-preloader">
                    <img src={`${image}${appname}/images/web/Loader.svg`} />
                </div>
            </div>

        </>
    );
};


export default TableLoader;



